/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { PropertyOperation } from './PropertyOperation';
/**
 * TSOA-friendly publication payload used by the MeLi sync endpoint.
 */
export type MeliItemSyncPublication = {
    /**
     * Local portal identifier used by `PropertyPortalPublication`.
     */
    portal: MeliItemSyncPublication.portal;
    /**
     * External listing/publication identifier in the provider.
     */
    externalListingId: string;
    /**
     * Public permalink to the listing, when exposed by the provider.
     */
    externalUrl?: string | null;
    /**
     * Operation represented by the external listing, when known.
     */
    operation?: PropertyOperation | null;
    /**
     * Provider-specific target or destination label.
     */
    portalTarget?: string | null;
    /**
     * Raw provider lifecycle status.
     */
    providerStatus?: string | null;
    /**
     * Raw provider sub-status values, when available.
     */
    providerSubStatus?: Array<string> | null;
    /**
     * Provider timestamp for the first publish, when available.
     */
    publishedAt?: string | null;
    /**
     * Provider timestamp for the latest listing update.
     */
    lastUpdated?: string | null;
    /**
     * Provider-specific publication metadata/config.
     */
    config?: Dictionary_unknown_ | null;
};
export namespace MeliItemSyncPublication {
    /**
     * Local portal identifier used by `PropertyPortalPublication`.
     */
    export enum portal {
        MELI = 'meli',
    }
}

